import { Messages } from '../../../../codegen/Localize';
import { IServerUserInfo } from '../../../../ts/models/IServerUserInfo';
import { serverUserDelete } from '../../../actions/spaces/ServerUserMenuActions';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { isSingleSelectServerUserGuest } from './IEntityActionHelpers';

export const ServerUserDeleteUsersAction: IEntityAction<IServerUserInfo, {}> = {
  name: EntityActionNames.ServerUserDeleteUsers,
  translateName: Messages.delete_action,
  isVisible: (_targetItems: IServerUserInfo[], _state: AppState) => {
    return true;
  },
  isClickable: (_availableActions: {}, targetItems: IServerUserInfo[], _state: AppState) => {
    return targetItems.length > 0 && !isSingleSelectServerUserGuest(targetItems);
  },
  createReduxAction: (targetItems: IServerUserInfo[]) => serverUserDelete(targetItems)
};
